import { Swiper, SwiperSlide } from 'swiper/react';
import { Autoplay, Navigation, Pagination, Scrollbar } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import 'swiper/css/bundle';
import './VideoGallery.css';
import { VideoGalleryController } from './VideoGalleryController';
import { IModalVideoControllerReturn } from '../../modals/modalvideo/ModalVideoController';
import VideoGalleryService from './VideoGalleryService';
import { IDeviceStateControllerReturn } from '../../../services/devicestate/DeviceStateController';


export interface IVideoItem {
  header?: string;
  img?: string;
  src: string;
  videoSizeRatio: number;
}

interface IProps {
  dsc: IDeviceStateControllerReturn;
  mvc: IModalVideoControllerReturn;
  videos: IVideoItem[];
  height: number;
}

const VideoSlideGallery = (props: IProps) => {

  const vgs = new VideoGalleryService();
  const vgc = VideoGalleryController({dsc:props.dsc});
  VideoGalleryService.itemsSize = [props.height,props.height];

  const GetPlayButton = (p: { it: IVideoItem }): JSX.Element => {
    //if (!vgc.isLoaded) return <></>

    return <div className={`absolute w-full h-full justify-center`} >
      {vgs.getPlay({
        //size: [VideoGalleryService.itemsSize[1].toString() + "px", VideoGalleryService.itemsSize[1].toString() + "px"], t: [0, 0],
         size: ["100%", "100%"],
        //size: [100, 100], t: [0, 0],
        onClick: () => props.mvc.setContentAndShow({ src: p.it.src, videoSizeRatio: p.it.videoSizeRatio })
      })}

    </div>
  }

  return (<>
    <div
      id="swiper_video_wrapper"
      ref={vgc.setRefSwiperWrapper}
      className={`w-full mx-auto`}
      //className={`w-full mx-auto ${props.dsc.small ? "pl-1" : "pl-r pr-5"} `}
    >
      <Swiper
        ref={(it) => { vgc.setRefSwiper(it) }}
        modules={[Navigation, Pagination, Scrollbar, Autoplay]}
        direction={"horizontal"}
        spaceBetween={10}
        onSwiper={(it) => {vgc.setSwiperInstance(it) }}
        onSlideChange={(it) => vgc.handleSlideChange(it)}
        //slidesPerView={vgc.slidesPerView}
        slidesPerView={1}
        navigation
        //navigation={{ nextEl: '.swiper-button-next', prevEl: '.swiper-button-prev' }}
        //scrollbar={{ draggable: true, el: '.swiper-scrollbar', }}
        //pagination={{ clickable: true, el: '.swiper-pagination-video' }}
        pagination={{ clickable: true}}
        //autoplay={{ delay: 3000, disableOnInteraction: true }}
        loop={true}
        className="swiper rounded-lg shadow-lg cursor-pointer flex flex-col bg-gray-800"
      >
        <div className="flex items-center justify-center" >
          {props.videos.map((it, index) => (
            <>
              <div
                key={it.src + index.toString()}
                className='flex flex-col'
              >
                <SwiperSlide
                  key={it.src}
                  className='m-auto'>
                  <div className='whitespace-nowrap mb-2 text-xl text-center' >{it.header} </div>
                  <div
                    className='relative flex items-center justify-center'
                    ref={(it) => {
                      if(it == null || it == undefined) return;
                      vgc.setRefSlideWrapper(it)
                    }}
                  >
                    <img
                      //loading='lazy'
                      className={`object-cover rounded-2xl m-auto`}
                      width={(props.height) * it.videoSizeRatio}
                      key={index}
                      src={it.img}
                      alt={`Slide ${index + 1}`}
                    />

                   <GetPlayButton
                      key={vgc.render}
                      it={it} />
           

                  </div>
                </SwiperSlide>
              </div>
            </>
          ))}

        </div>

        {/* <div className="h-full left-0 w-[6rem] top-0 m-auto swiper-button-prev"></div>
        <div className="h-full right-0 w-[6rem] top-0 m-auto swiper-button-next"></div> */}

        <div id="swiper_footer" className='relative h-10 w-full' >
          <div className="swiper-pagination" />
        </div>

        {/* <div id="swiper_footer" className='relative h-10 w-full' >
          <div className="swiper-pagination"/>
        </div> */}
      </Swiper>
    </div>
    </>
  );
};

export default VideoSlideGallery;
